import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const imageLinkExpungeFailureSlice = createSlice({
  name: 'imageLinkExpungeFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    imageLinkExpungeFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    imageLinkExpungeFailureClear(state) {
      return null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { imageLinkExpungeFailureChange, imageLinkExpungeFailureClear } = imageLinkExpungeFailureSlice.actions;

// export the core reducer for the slice
export const imageLinkExpungeFailureReducer = imageLinkExpungeFailureSlice.reducer;

export default imageLinkExpungeFailureSlice.reducer;